module.exports = __webpack_public_path__ + "uia-showroom.74c592db7b83cf9d392e030ad6dba8f0.svg";